/* eslint-disable @typescript-eslint/no-explicit-any */
import 'knockout.validation';
import ko from 'knockout';

export class EmailViewModel {
    public value = ko.observable<string>();
    public isValid = ko.pureComputed(() => {
        const emailValidator = ko.validation.rules['email'].validator;
        return this.value() && emailValidator(this.value(), true);
    });

    constructor(parent: any) {
        this.value.extend({
            email: {
                message: 'Angiv venligst en gyldig e-mail.',
                onlyIf: function () {
                    return parent.validateNow();
                },
            },
        });
    }
}
